import React, { Component } from 'react'
import '../../../styles/checkout/mainStyle.css'
import { connect } from 'react-redux'
import { toggleDisplayIframe, setTerminateCheckout, setNotDisplayCheckout, updateCallbackConsole} from  '../../../actions/checkoutActions'

export class Terminate extends Component {
    constructor(props) {
        super(props); 
        this.startToTerminate =this.startToTerminate.bind(this)
      }

    state={
        firstCheck:true,
        showError:false,
        showSuccess:false,
        justClicked:false,
        counter:0
    }

    onScrollToTop() {
        this.state.topRef.current.scrollIntoView()
        window.document.body.scrollIntoView(true)
    }

    startToTerminate() { 
        this.props.toggleDisplayIframe()
        this.props.setNotDisplayCheckout()
        this.props.setTerminateCheckout()
        this.props.updateCallbackConsole("empty")
        this.setState({justClicked:true})
        this.setState({ showError: false, firstCheck:false,showSuccess: true,justClicked:false });  
    }

    renderMessage() {
        if(this.state.showError) {
            return (
                <div style={{ marginTop:'1vh', marginRight: '3vw',backgroundColor:'#ffcccc', color:'#cc0000', padding:'1vw', borderRadius:'10px', border:'1px solid #ff8080', lineHeight: '3vh'}}><strong>Error!</strong><br />Please check your parameters within receipt request.</div>
            );
        }
        else if(this.state.showSuccess) {
            return (
                <div style={{ marginTop:'1vh', marginRight: '3vw',backgroundColor:'#d6f5d6', color:'#196719', padding:'1vw', borderRadius:'10px', border:'1px solid #6fdc6f', lineHeight: '3vh'}}><strong>You have terminated the instance!</strong><br />The callback queue has also been emptied, you can start a new checkout instance now .</div>
            );
        }
    }
    renderInteractiveTool(){
        return (
            <div className="stepMainContainer">
                <p style={{marginTop: '5vh'}}>To terminate the Moneris Checkout instance, call myCheckout.closeCheckout(), for example:</p>
                <pre>
                    <span id="code6">myCheckout.closeCheckout("{this.props.ticket}");
                    </span>
                </pre>
                <div className="requestButton" onClick={() => this.startToTerminate()}>Terminate</div>
                {this.renderMessage()}
            </div>
        )

    }

    renderDocument() {
        return (
            <div className="stepPageContainer">
                <h3 ref={this.state.topRef} className="stepPageTitle">Terminate Instance</h3> 
                <p>To terminate the Moneris Checkout instance, call myCheckout.closeCheckout(), for example:</p>
                <pre>
                myCheckout.closeCheckout("<span id="ticketNumber2"> {this.props.ticket}</span>");
                </pre>
                {this.renderMessage()}
            </div>
        )

    }
    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderInteractiveTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
      }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    const { ticket,ifTerminateCheckout,ifDisplayCheckout  } = state.checkout.main;
    return { mode, ticket ,ifTerminateCheckout,ifDisplayCheckout };
}

export default connect(mapStateToProps,{toggleDisplayIframe,setTerminateCheckout,setNotDisplayCheckout,updateCallbackConsole})(Terminate)

